export function SectionHeader({ title, subtitle, action }) {
  return (
    // Stack on mobile so the action (e.g. "New poll" + Import) never collides
    // with / overlaps the title+subtitle in narrow sidebar cards (bug-317).
    // min-w-0 + shrink-0 keep the title from pushing the action off-row on sm+.
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <h2 className="font-display text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h2>
        {subtitle && (
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
